import { InteractiveMapLocationSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getReturnBearLocations = {
  name: "getReturnBearLocations" as const,
  input: z.object({
    draftReturnId: zExt.objectId().nullish(),
    returnId: zExt.objectId().nullish(),
  }),
  output: z.object({ locations: z.array(InteractiveMapLocationSchema) }),
};
